module.exports = __webpack_public_path__ + "img/govlcon.2efb023c.gif";